import type { Options } from 'highcharts'

import { analyticsColors } from '~/const/chart'
import { removeInfSupTrendFromSeriesName } from '~/utils/chart'

export const SECONDS_IN_DAY = 24 * 3600 * 1000

export const defaultOptions: Options = {
  chart: {
    animation: false,
    events: {
      load() {
        setTimeout(() => {
          this.reflow.bind(this)
        }, 1000)
      },
    },
  },
  colors: analyticsColors,
  credits: {
    enabled: false,
  },
  legend: {
    align: 'center',
    alignColumns: false,
    enabled: true,
    itemMarginTop: 1,
    layout: 'horizontal',
    maxHeight: 75,
    verticalAlign: 'top',
  },
  navigator: { outlineColor: '#e9e9e9' },
  plotOptions: {
    series: {
      animation: {
        duration: 0,
      },
      cropThreshold: 300,
      showInNavigator: true,
    },
  },
  rangeSelector: {
    enabled: false,
  },
  title: undefined,
  tooltip: {
    backgroundColor: '#FFFFFF',
    borderColor: '#1d1d1d',
    footerFormat: '</div>',
    headerFormat: '<div><div><b>{point.key}</b><div><br/>',
    outside: true,
    padding: 12,
    shared: true,
    split: false,
    style: {
      zIndex: 10,
    },
    useHTML: true,
    xDateFormat: '%b %d, %Y',
  },
  xAxis: {
    labels: {
      formatter: function () {
        return this.axis.defaultLabelFormatter.call(this).split('.').reverse().join(' ')
      },
    },
    minRange: SECONDS_IN_DAY,
  },
}

export const cohortedAnalyticsDefaultOptions: Options = {
  ...defaultOptions,
  plotOptions: {
    series: {
      events: {
        legendItemClick: function () {
          const series = this.chart.series

          const chart = this.chart as any

          if (this.visible) {
            series.forEach((el) => {
              removeInfSupTrendFromSeriesName(el.name) === this.name &&
                el.setVisible(false, chart.types.includes('column'))
            })
          } else {
            series.forEach((el) => {
              removeInfSupTrendFromSeriesName(el.name) === this.name &&
                el.setVisible(true, chart.types.includes('column'))
            })
          }

          return false
        },
      },
    },
  },
  scrollbar: {
    enabled: false,
  },
  xAxis: {
    gridLineWidth: 1,
    labels: {
      formatter: function () {
        return this.axis.defaultLabelFormatter.call(this).split('.').reverse().join(' ')
      },
    },
    minRange: SECONDS_IN_DAY,
    tickInterval: SECONDS_IN_DAY,
  },
}
